/**
 * Fields module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import AdminAjax from '@src/Fields/Pages/Fields/AdminAjax.vue';
import AdminDate from '@src/Fields/Pages/Datetime/AdminDate.vue';
import AdminDatetime from '@src/Fields/Pages/Datetime/AdminDatetime.vue';
import AdminDateRelative from '@src/Fields/Pages/Datetime/AdminDateRelative.vue';
import Calendar from '@src/Fields/Pages/Datetime/Calendar.vue';
import Timepicker from '@src/Fields/Pages/Datetime/Timepicker.vue';
import TimeInput from '@src/Fields/Pages/Datetime/TimeInput.vue';
import AdminTime from '@src/Fields/Pages/Datetime/AdminTime.vue';
import Datepicker from '@src/Fields/Pages/Datetime/Datepicker.vue';
import AdminCheckbox from '@src/Fields/Pages/Fields/AdminCheckbox.vue';
import AdminColor from '@src/Fields/Pages/Fields/AdminColor.vue';
import AdminColorPalette from '@src/Fields/Pages/Fields/AdminColorPalette.vue';
import AdminColorWheel from '@src/Fields/Pages/Fields/AdminColorWheel.vue';
import AdminEmail from '@src/Fields/Pages/Fields/AdminEmail.vue';
import AdminFile from '@src/Fields/Pages/Files/AdminFile.vue';
import AdminFieldGroup from '@src/Fields/Pages/Fields/AdminFieldGroup.vue';
import AdminHTML from '@src/Fields/Pages/HTML/AdminHTML.vue';
import AdminHTMLLive from '@src/Fields/Pages/HTML/AdminHTMLLive.vue';
import AdminHTMLLiveDoc from '@src/Fields/Pages/HTML/AdminHTMLLiveDoc.vue';
import AdminNumber from '@src/Fields/Pages/Fields/AdminNumber.vue';
import AdminOpeningHours from '@src/Fields/Pages/Fields/AdminOpeningHours.vue';
import AdminPassword from '@src/Fields/Pages/Fields/AdminPassword.vue';
import AdminRadio from '@src/Fields/Pages/Fields/AdminRadio.vue';
import AdminRadioGroup from '@src/Fields/Pages/Fields/AdminRadioGroup.vue';
import AdminRange from '@src/Fields/Pages/Fields/AdminRange.vue';
import AdminRelation from '@src/Fields/Pages/Fields/AdminRelation.vue';
import AdminRepeater from '@src/Fields/Pages/Repeater/AdminRepeater.vue';
import AdminSearch from '@src/Fields/Pages/Fields/AdminSearch.vue';
import AdminSelect from '@src/Fields/Pages/Fields/AdminSelect.vue';
import AdminSelectIcon from '@src/Fields/Pages/Fields/AdminSelectIcon.vue';
import AdminSelectPills from '@src/Fields/Pages/Fields/AdminSelectPills.vue';
import AdminSlug from '@src/Fields/Pages/Fields/AdminSlug.vue';
import AdminStepper from '@src/Fields/Pages/Fields/AdminStepper.vue';
import AdminSuggestions from '@src/Fields/Pages/Fields/AdminSuggestions.vue';
import AdminSwitchGroup from '@src/Fields/Pages/Fields/AdminSwitchGroup.vue';
import AdminTable from '@src/Fields/Pages/Fields/AdminTable.vue';
import AdminTableRepeater from '@src/Fields/Pages/Fields/AdminTableRepeater.vue';
import AdminText from '@src/Fields/Pages/Fields/AdminText.vue';
import AdminTel from '@src/Fields/Pages/Fields/AdminTel.vue';
import AdminTextarea from '@src/Fields/Pages/Fields/AdminTextarea.vue';
import AdminUuid from '@src/Fields/Pages/Fields/AdminUuid.vue';
import AdminWYSIWYG from '@src/Fields/Pages/WYSIWYG/AdminWYSIWYG.vue';
import AdminMarkdown from '@src/Fields/Pages/WYSIWYG/AdminMarkdown.vue';
import AdminMessage from '@src/Fields/Pages/Fields/AdminMessage.vue';
import AdminPriceCents from '@src/Fields/Pages/Fields/AdminPriceCents.vue';
import CopyToClipboard from '@src/Fields/Pages/Fields/CopyToClipboard.vue';
import ShowLink from '@src/Fields/Pages/Fields/ShowLink.vue';
import ShowText from '@src/Fields/Pages/Fields/ShowText.vue';
import FieldEditor from '@src/Fields/Pages/Editors/FieldEditor.vue';
import GridBoolean from '@src/Fields/Pages/Fields/GridBoolean.vue';
import GridFiles from '@src/Fields/Pages/Files/GridFiles.vue';
import GridPriceCents from '@src/Fields/Pages/Fields/GridPriceCents.vue';

export const setup = (app: App<Element>): void => {
    app.component('AdminDate', AdminDate);
    app.component('AdminDatetime', AdminDatetime);
    app.component('AdminDateRelative', AdminDateRelative);
    app.component('AdminTime', AdminTime);
    app.component('Calendar', Calendar);
    app.component('Datepicker', Datepicker);
    app.component('Timepicker', Timepicker);
    app.component('TimeInput', TimeInput);

    app.component('AdminAjax', AdminAjax);
    app.component('AdminCheckbox', AdminCheckbox);
    app.component('AdminColor', AdminColor);
    app.component('AdminColorPalette', AdminColorPalette);
    app.component('AdminColorWheel', AdminColorWheel);
    app.component('AdminEmail', AdminEmail);
    app.component('AdminFieldGroup', AdminFieldGroup);
    app.component('AdminFile', AdminFile);
    app.component('AdminHTML', AdminHTML);
    app.component('AdminHTMLLive', AdminHTMLLive);
    app.component('AdminHTMLLiveDoc', AdminHTMLLiveDoc);
    app.component('AdminMarkdown', AdminMarkdown);
    app.component('AdminMessage', AdminMessage);
    app.component('AdminNumber', AdminNumber);
    app.component('AdminOpeningHours', AdminOpeningHours);
    app.component('AdminPassword', AdminPassword);
    app.component('AdminPriceCents', AdminPriceCents);
    app.component('AdminRadio', AdminRadio);
    app.component('AdminRadioGroup', AdminRadioGroup);
    app.component('AdminRange', AdminRange);
    app.component('AdminRelation', AdminRelation);
    app.component('AdminSearch', AdminSearch);
    app.component('AdminSelect', AdminSelect);
    app.component('AdminSelectIcon', AdminSelectIcon);
    app.component('AdminSelectPills', AdminSelectPills);
    app.component('AdminSlug', AdminSlug);
    app.component('AdminStepper', AdminStepper);
    app.component('AdminSuggestions', AdminSuggestions);
    app.component('AdminSwitchGroup', AdminSwitchGroup);
    app.component('AdminTable', AdminTable);
    app.component('AdminTableRepeater', AdminTableRepeater);
    app.component('AdminTel', AdminTel);
    app.component('AdminText', AdminText);
    app.component('AdminTextarea', AdminTextarea);
    app.component('AdminUuid', AdminUuid);
    app.component('AdminWYSIWYG', AdminWYSIWYG);

    app.component('AdminRepeater', AdminRepeater);

    app.component('FieldEditor', FieldEditor);

    app.component('CopyToClipboard', CopyToClipboard);

    app.component('ShowLink', ShowLink);
    app.component('ShowText', ShowText);

    app.component('GridBoolean', GridBoolean);
    app.component('GridFiles', GridFiles);
    app.component('GridPriceCents', GridPriceCents);
};
